import { Component, Inject, Input, OnInit } from '@angular/core';

import { InfillTypes } from '../../../../services/railing/infills/model/infill-types';
import { LASER_CUT_DESIGNS } from '../../../../services/railing/infills/model/laser-cut-designs.config';

@Component({
  selector: 'app-modal-get-quote-pdf',
  templateUrl: './modal-get-quote-pdf.component.html',
  styleUrls: ['./modal-get-quote-pdf.component.scss']
})
export class ModalGetQuotePdfComponent implements OnInit {
  @Input() form;
  @Input() dealer;
  @Input() screenShot;
  @Input() accessories;
  @Input() infillType;
  @Input() projectUrl;
  infillLaserCatTypes = LASER_CUT_DESIGNS.map(design => ({
    infillType: design.key,
    style: design.quoteName
  }));
  infillGlassClearTypes: string[]= [
    InfillTypes.glassClear,
    InfillTypes.glassSmoke,
    InfillTypes.glassDark
  ];
  infillSteelMeshTypes: string[]= [
    InfillTypes.steelMeshAllure,
    InfillTypes.steelMeshDazzle,
    InfillTypes.steelMeshMetropolitan,
    InfillTypes.steelMeshHorizon
  ];

  constructor() {}

  gatesChecking() {
    if (this.accessories && this.accessories.length) {
      return this.accessories.find(acc => acc.name === 'Gate');
    } else {
      return false;
    }
  }

  checkInfillOptions(infill, option) {
    if (this.form && this.form.get('infill').value === infill && this.form.get(option) && this.form.get(option).value) {
      return true;
    } else {
      return false;
    }
  }

  ngOnInit() {
    console.log('accessories', this.accessories);
    // this._createForm();
    // this.pdfService.createPdfProject('test');
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-get-quote/modal-get-quote-pdf/modal-get-quote-pdf.component.ts